import {atomWithStorage} from 'jotai/utils';

export type CalendarTileView = 'calendar' | 'list';

/** Remembers the viewer's calendar/list preference across sessions. */
export const calendarViewAtom = atomWithStorage<CalendarTileView>(
  'dashboard:peopleCalendarView',
  'calendar'
);
